import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { JumpPageSectionProps } from '../../jump-page-body';
import YouDeserveItem from './you-deserve-item';

const content = [
  {
    title: 'It won’t affect your credit score',
    content: 'There’s no hard credit check required to see your results.',
  },
  {
    title: 'See smart recommendations in minutes',
    content:
      'We only ask questions that are essential. No contact info required.',
  },
  {
    title: 'Tap into objective ratings',
    content: 'See the pros and cons of each credit card we recommend.',
  },
];

const imgUrl =
  'https://www.nerdwallet.com/cdn/performance-marketing-client/hand-with-multiple-credit-cards%201.svg';

const YouDeserveSection: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();
  const { ref } = useImpressionEvent({
    eventType: EventType.ElementImpression,
    navigationId,
    payload: {
      entity_name: EntityName.JumpDeserve,
      section_name: SectionName.JumpDeserve,
      section_position: 1,
    },
  });

  return (
    <Box
      ref={ref}
      display="flex"
      justifyContent="center"
      paddingY={3.5}
      paddingX={0}
    >
      <Box
        display="flex"
        flexDirection="row"
        position="relative"
        sx={{ [theme.breakpoints.up('sm')]: { maxWidth: '80%' } }}
      >
        <Box
          component="img"
          src={imgUrl}
          alt=""
          sx={{
            [theme.breakpoints.down('md')]: {
              position: 'absolute',
              height: '4rem',
              width: '4rem',
              right: '1rem',
            },
          }}
        />
        <Box
          marginLeft={2}
          display="flex"
          flexDirection="column"
          sx={{ [theme.breakpoints.down('md')]: { marginLeft: 0 } }}
        >
          <Typography
            variant="bodyLargeBlack"
            marginLeft={3}
            paddingLeft={4}
            sx={{
              [theme.breakpoints.down('md')]: { width: '80%', paddingLeft: 0 },
            }}
            component="h2"
          >
            You deserve a great credit card.
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            marginTop={3.5}
            marginLeft={5}
            sx={{
              [theme.breakpoints.down('md')]: {
                marginLeft: 3,
                paddingRight: 3,
              },
            }}
          >
            {content.map((item) => (
              <YouDeserveItem
                title={item.title}
                content={item.content}
                key={item.title}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default YouDeserveSection;
